import request from '@/utils/request'

/**
 *  开单首页
 */
// 购物车列表 
export const shopCar_list = (data) => {
    return request({
        url: '/erp/order-shop-cart/index',
        method: 'get',
        data
    })
}

// 获取单个购物车 
export const shopCar_one = (data) => {
    return request({
        url: '/erp/order-shop-cart/get-data',
        method: 'get',
        data
    })
}

// 保存单个购物车 
export const shopCar_update = (data) => {
    return request({
        url: '/erp/order-shop-cart/save-data',
        method: 'post',
        data
    })
}

// 删除单个购物车 
export const shopCar_delete = (data) => {
    return request({
        url: '/erp/order-shop-cart/edit-status',
        method: 'post',
        data
    })
}


// 收银台开单
export const shopCarCheckOut_open = (data) => {
    return request({
        url: '/erp/order-draft-main/billing',
        // url: '/erp/order-draft/billing',
        method: 'post',
        data
    })
}


// 收银台添加 结账
export const shopCarCheckOut_submit = (data) => {
    return request({
        url: '/erp/order-draft-main/staff-create',
        method: 'post',
        data
    })
}

// 收银台添加一个商品
export const shopCarCheckOut_addGoods = (data) => {
    return request({
        url: '/erp/order-draft-main/cash-create',
        method: 'post',
        data
    })
}


// 收银台修改一个商品
export const shopCarCheckOut_updateGoods = (data) => {
    return request({
        url: '/erp/order-draft-main/edit',
        method: 'post',
        data
    })
}


// 收银台列表
export const shopCarCheckOut_getList = (data) => {
    return request({
        url: '/erp/order-draft-main/buyer-list',
        // url: '/erp/order-draft/buyer-list',
        method: 'post',
        data
    })
}

// 收银台订单详情
export const shopCarCheckOut_getDetail = (data) => {
    return request({
        url: '/erp/order-draft-main/detail',
        // url: '/erp/order-draft/list',
        method: 'post',
        data
    })
}

// 收银台列表 删除商品
export const shopCarCheckOut_deleteGoods = (data) => {
    return request({
        url: '/erp/order-draft-main/goods-delete',
        // url: '/erp/order-draft/delete',
        method: 'post',
        data
    })
}

// 结账时检测商品告罄和员工新增商品接口
export const shopCarCheckOut_checkGoods = (data) => {
    return request({
        url: '/erp/order-draft-main/bill',
        // url: '/erp/order-draft/bill',
        method: 'post',
        data
    })
}


// 收银台列表 删除订单
export const shopCarCheckOut_deleteOrder = (data) => {
    return request({
        url: '/erp/order-draft-main/delete',
        // url: '/erp/order-draft/delete-all',
        method: 'post',
        data
    })
}


// 货品列表
export const order_pay = (data) => {
    return request({
        url: '/erp/order-total/create',
        method: 'post',
        data
    })
}


// 货品列表
export const baseGoods_list = (data) => {
    return request({
        url: '/erp/base-goods/list',
        method: 'post',
        data
    })
}

// 附加费—列表
export const baseSurcharge_list = (data) => {
    return request({
        url: '/erp/base-surcharge/list',
        method: 'post',
        data
    })
}

// 查询最新商品
export const changeGoods_get = (data) => {
    return request({
        url: '/erp/base-surcharge/goods-list',
        method: 'post',
        data
    })
}

// 提交最新商品
export const changeGoods_set = (data) => {
    return request({
        url: '/erp/base-surcharge/goods-create',
        method: 'post',
        data
    })
}


// 店铺以及人物id
export const uidAndMId = (data) => {
    return request({
        url: '/erp/order-draft/getum',
        method: 'post',
        data
    })
}

// 付款扫码
export const orderPayPos = (data) => {
    return request({
        url: '/erp/order-total/order-pay',
        method: 'post',
        data
    })
}

// 查询订单结果
export const orderQueryResult = (data) => {
    return request({
        url: '/erp/order-total/order-query',
        method: 'post',
        data
    })
}

// 支付方式
export const orderPayType = (data) => {
    return request({
        url: '/erp/order-draft/pay',
        method: 'post',
        data
    })
}


// 打印订单
export const orderPrint = (data) => {
    return request({
        url: '/erp/order-total/temp-print',
        // url: '/erp/order-draft/print',
        method: 'post',
        data
    })
}

//开单-保存备注
export const order_desc=(data)=>{
    return request({
      url: '/erp/order-shop-cart/desc',
      method: 'post',
      data
    })
  }

//销售中的商品分类列表
export const goods_type_list=(data)=>{
    return request({
      url: '/erp/base-goods-cate/get-sale-cate',
      method: 'post',
      data
    })
  }

// 长链接监听有没有新的数据
export const ws_url = process.env.VUE_APP_BASE_API_WS